import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

import { MemberCommentsListComponent } from '../member-comments-list/member-comments-list.component';

@Component({
  selector: 'members-comments-card',
  standalone: true,
  imports: [CdkOverlayOrigin, CdkConnectedOverlay, MatCard, MatCardContent, MatIcon, TranslatePipe, MemberCommentsListComponent],
  templateUrl: './member-comments-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberCommentsCardComponent {
  readonly memberId = input.required<string>();

  protected readonly cardOpen = signal<boolean>(false);

  protected toggleCard(): void {
    this.cardOpen.update(open => !open);
  }

  protected closeCard(): void {
    this.cardOpen.set(false);
  }
}
